// components/secure/Modal.js
// Shared pop-up used by the admin pages so list views stay uncrowded:
// all create/edit/view happens in these overlays.

import React from 'react';

const SIZES = { sm: 'max-w-md', md: 'max-w-2xl', lg: 'max-w-4xl' };

const Modal = ({ open, onClose, title, size = 'md', children, footer }) => {
    if (!open) return null;
    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className={`bg-white rounded-lg shadow-xl w-full ${SIZES[size] || SIZES.md} max-h-[85vh] flex flex-col`}
                 onClick={e => e.stopPropagation()}>
                <div className="flex items-center justify-between gap-3 px-4 sm:px-6 py-4 border-b">
                    <h2 className="text-lg font-semibold text-slate-800">{title}</h2>
                    <button onClick={onClose} aria-label="Close" className="text-slate-400 hover:text-slate-600 text-2xl leading-none px-2 -mr-2">×</button>
                </div>
                <div className="px-4 sm:px-6 py-4 overflow-y-auto flex-1">{children}</div>
                {footer && <div className="px-4 sm:px-6 py-3 border-t bg-slate-50 rounded-b-lg flex flex-wrap justify-end gap-3">{footer}</div>}
            </div>
        </div>
    );
};

export default Modal;
